import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContactEmployeeType } from "../../Types/HeyTraderTypes/Attendances/ContactEmployeeType";
import { getContactEmployeeList } from "../../Thunks/HeyTraderThunks";

interface ContactEmployeeSliceState {
    loader: boolean; // for refres pages and inital loadings
    contactEmployeeList: ContactEmployeeType[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : ContactEmployeeSliceState = {
    loader: false,
    contactEmployeeList: [],
    errorDisplay: '',

}

// set state valu for api response
const contactEmployeeSlice = createSlice ({
    name: 'contactEmployees',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getContactEmployeeList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getContactEmployeeList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getContactEmployeeList.fulfilled, (state, action: PayloadAction<ContactEmployeeType[]>) => {
                    state.loader = false;
                    state.contactEmployeeList = action.payload;
                  })
    }
})

export const {} = contactEmployeeSlice.actions
export default contactEmployeeSlice.reducer
